import { Authenticated, Unauthenticated, AuthLoading } from "convex/react";
import { useTheme } from "./lib/theme";
import { Marketing } from "./components/marketing/Marketing";
import { AppShell } from "./components/app/AppShell";

export function App() {
  const { theme, toggle } = useTheme();

  return (
    <>
      <AuthLoading>
        <div className="center-screen">
          <div className="spinner" aria-label="Loading" />
        </div>
      </AuthLoading>
      <Unauthenticated>
        <Marketing theme={theme} onToggleTheme={toggle} />
      </Unauthenticated>
      <Authenticated>
        <AppShell theme={theme} onToggleTheme={toggle} />
      </Authenticated>
    </>
  );
}
